
import mapOriginal from '../common/client/reducers/map';

export default function map(state, action) {
    switch (action.type) {

        default:
            return mapOriginal(state, action);
    }
}
